const types = {
    ORGANISATIONS_SEARCH_FAILED: "DINGS/ORGANISATIONS_SEARCH_FAILED",
    ORGANISATIONS_SEARCH_REQUEST: "DINGS/ORGANISATIONS_SEARCH_REQUEST",
    ORGANISATIONS_SEARCH_SUCCESS: "DINGS/ORGANISATIONS_SEARCH_SUCCESS",
};

export default types;
